import { useState } from 'react'
import { Button } from '@mui/material'

import { ImpactLibrarySuggestion } from './impact-library-suggestion.component'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const SuggestButton = () => {
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <div>
      <Button onClick={handleOpen} size="small" variant="outlined">
        <HelperWrapper t="impact-library-suggest-button" isColorInherited />
      </Button>
      <ImpactLibrarySuggestion open={open} handleClose={handleClose} />
    </div>
  )
}
